import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=5e2d01cc&scoped=true&"
import script from "./assignment.vue?vue&type=script&lang=js&"
export * from "./assignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d01cc",
  null
  
)

export default component.exports